<div class="container-fluid px-0">
  <ul class="nav-tabs nav-fill" ngbNav #nav="ngbNav" (navChange)="onNavChange($event)" [activeId]="activeTabId">
    <li [ngbNavItem]="'users'">
      <a ngbNavLink><h5 class="text-secondary" id="usersTitle">Utilisateurs</h5></a>
      <ng-template ngbNavContent>
        <app-admin-users></app-admin-users>
      </ng-template>
    </li>
    <li [ngbNavItem]="'structures'">
      <a ngbNavLink><h5 class="text-secondary" id="structuresTitle">Structures</h5></a>
      <ng-template ngbNavContent>
        <app-admin-structures></app-admin-structures>
      </ng-template>
    </li>
    <li [ngbNavItem]="'import'">
      <a ngbNavLink><h5 class="text-secondary">Import</h5></a>
      <ng-template ngbNavContent>
        <app-admin-import></app-admin-import>
      </ng-template>
    </li>
    <li [ngbNavItem]="'merge'">
      <a ngbNavLink><h5 class="text-secondary">Fusion</h5></a>
      <ng-template ngbNavContent>
        <app-admin-merge></app-admin-merge>
      </ng-template>
    </li>
    <li [ngbNavItem]="'general'">
      <a ngbNavLink><h5 class="text-secondary">Général</h5></a>
      <ng-template ngbNavContent>
        <app-admin-general></app-admin-general>
      </ng-template>
    </li>
    <li [ngbNavItem]="'admin-monitor'">
      <a ngbNavLink><h5 class="text-secondary">Moniteur</h5></a>
      <ng-template ngbNavContent>
        <app-performance-monitor></app-performance-monitor>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
